import React from 'react'
import img_frontend from '../Languages/assets/img_frontend.jpg'
import img_backend from '../Languages/assets/img_backend.jpg'
const Web_dev = () => {
    return (
        <div className='container'>
            <div class="w3-col l10 m12" id="main">
    <div id="mainLeaderboard" style={{overflow:'hidden'}}>
   

      
        <div id="snhb-main_leaderboard-0"></div>
    

    </div>
    <h1>Web Development Roadmaps</h1>
    <br/> <br/> <br/> <br/>
    <hr/>

    <h1 class="w3-center">Front-End Roadmap</h1>

    <div style={{padding:'16px'}} class="w3-blue-grey w3-card-4">
        <div class="w3-container w3-center">
            <h1>STEP 1<br/>
                Learn the Basics</h1>
        </div>
        <div class="w3-container w3-white w3-card">
            <p>Every <b>Web Developer</b> must have a basic understanding of <b>HTML</b>, <b>CSS</b>, and
                <b>JavaScript</b>.</p>
            <p><b>Responsive Web Design</b> is used in all types of modern web development.</p>
            <p><b>ECMAScript 5</b> (JavaScript 5) is supported in all modern browsers.
                Take a good look at it, especially the new array functions.</p>
        </div>

        <div class="w3-row-padding w3-stretch">
            <div class="w3-third">
                <div class="w3-bar-block w3-white">
                    <h2 class="w3-bar-item">HTML</h2>
                    <ol>
                  <li>  HTML</li>
                  <li>  HTTP / XHR</li></ol>
                </div>
            </div>
            <div class="w3-third">
                <div class="w3-bar-block w3-white">
                    <h2 class="w3-bar-item">CSS</h2>
                    <ol>
                    <li href="whatis_css.asp" class="w3-bar-item w3-button w3-orange">CSS</li>
                    <li href="whatis_responsive.asp" class="w3-bar-item w3-button w3-orange">CSS Responsive</li></ol>
                </div>
            </div>
            <div class="w3-third">
                <div class="w3-bar-block w3-white">
                    <h2 class="w3-bar-item">JavaScript</h2>
                    <ol>
                    <li href="whatis_js.asp" class="w3-bar-item w3-button w3-orange">JavaScript</li>
                    <li href="whatis_es5.asp" class="w3-bar-item w3-button w3-orange">ECMAScript 5</li></ol>
                </div>
            </div>
        </div>
        <br/>

    </div>
    <br/>

    <div style={{padding:'16px 16px 32px 16px'}} class="w3-dark-grey w3-card-4">
        <div class="w3-container w3-center">
            <h1>STEP 2<br/>
                Dig Deeper</h1>
        </div>

        <div class="w3-container w3-white w3-card">
            <p>When you feel comfortable with <b>HTML</b> and <b>CSS</b>, it is time to dig deeper.</p>
            <p>You should learn how to use <b>Maps</b>, <b>Fonts</b> and <b>Icons</b> in HTML.</p>
            <p>On the <b>JavaScript</b> side, you should learn how to access the <b>HTML DOM</b>.</p>
            <p>You should also learn how to use <b>AJAX</b> and <b>JSON</b> for making server requests.</p>
        </div>

        <div class="w3-row-padding" style={{margin:'0 -16px'}}>
            <div class="w3-third">
                <div class="w3-bar-block w3-white">
                    <h2 class="w3-bar-item">HTML</h2>
                    <li  class="w3-bar-item w3-button w3-orange">HTML DOM</li>
                    <li class="w3-bar-item w3-button w3-orange">Google Maps</li>
                    <li  class="w3-bar-item w3-button w3-orange">Google Fonts</li>
                    <li  class="w3-bar-item w3-button w3-orange">Google Charts</li>
                </div>
            </div>
            <div class="w3-third">
                <div class="w3-bar-block w3-white">
                    <h2 class="w3-bar-item">CSS</h2>
                    <br /> <br />
                    <ol>
                    <li  class="w3-bar-item w3-button w3-orange">CSS Icons</li></ol>
                </div>
            </div>
            <div class="w3-third">
                <div class="w3-bar-block w3-white">
                    <h2 class="w3-bar-item">JavaScript</h2>
                    <li  class="w3-bar-item w3-button w3-orange">XML</li>
                    <li  class="w3-bar-item w3-button w3-orange">JSON</li>
                    <li  class="w3-bar-item w3-button w3-orange">AJAX</li>
                </div>
            </div>
        </div>
    </div>
    <br/>

    <div class="w3-blue-grey w3-card-4" style={{padding:'16px 16px 32px 16px'}}>
        <div class="w3-container w3-center">
            <h1>STEP 3<br/>
                Choose Frameworks</h1>
        </div>
        <div class="w3-container w3-white w3-card">
            <p>Now it is time to look at some <b>Frameworks</b>.</p>
            <p>On the <b>CSS</b> side you should choose a framework for reponsive web design:<br/>

                <b>Bootstrap</b>&nbsp;&nbsp;/&nbsp;&nbsp;<b>Material Design</b>&nbsp;&nbsp;/&nbsp;&nbsp;<b>W3.CSS</b>
            </p>
            <p>On the <b>JavaScript</b> side you should learn at least one modern framework:<br/>

                <b>React.js</b>&nbsp;&nbsp;/&nbsp;&nbsp;<b>Angular.js</b>&nbsp;&nbsp;/&nbsp;&nbsp;<b>Vue.js</b>
                &nbsp;&nbsp;/&nbsp;&nbsp;<b>W3.JS</b>
            </p>
            <p>Maybe the popularity of <b>jQuery</b> has passed the top, but it is still the most used JavaScript
                framework.</p>
        </div>

        <div class="w3-row-padding" style={{margin:'0 -16px'}}>
            <div class="w3-third">
                <div class="w3-bar-block w3-white">
                    <h2 class="w3-bar-item">CSS</h2>
                    <li  class="w3-bar-item w3-button w3-orange">Bootstrap</li>
                    <li  class="w3-bar-item w3-button w3-orange">W3.CSS</li>
                </div>
            </div>
            <div class="w3-third">
                <div class="w3-bar-block w3-white">
                    <h2 class="w3-bar-item">JavaScript</h2>
                    <li>jQuery</li>
                    <li class="w3-bar-item w3-button w3-orange">AngularJS</li>
                    <li class="w3-bar-item w3-button w3-orange">Vue.js</li>
                    <li class="w3-bar-item w3-button w3-orange">W3.JS</li>
                </div>
            </div>
            <div class="w3-third">
                <div class="w3-card-4 w3-bar-block w3-white">
                    <h2 class="w3-bar-item">XML</h2>
                    <li  class="w3-bar-item w3-button w3-orange">XSLT</li>
                    <li  class="w3-bar-item w3-button w3-orange">XPath</li>
                    <li  class="w3-bar-item w3-button w3-orange">XQuery</li>
                </div>
            </div>
        </div>
    </div>

    <p><img alt="Roadmap" src={img_frontend} style={{width:'100%'}}/></p>
    <p class="w3-center">Chart created by GitHub user Kamranahmedse:
        <a target="_blank" href="https://github.com/kamranahmedse"><br/>
            https://github.com/kamranahmedse </a>
    </p>

    <h1 class="w3-center">Back-End Roadmaps</h1>
    <div class="w3-black w3-card-4" style={{padding:'16px 16px 32px 16px'}}>
        <h1 class="w3-center">STEP 4<br/>
            Back-End Roadmaps</h1>

        <div class="w3-row-padding" style={{margin:'0 -16px 0 -16px'}}>

            <div class="w3-half">
                <div class="w3-bar-block w3-white">
                    <h2 class="w3-bar-item">Fullstack</h2>
                    <ol>
                    <li  class="w3-bar-item w3-button w3-orange">SQL</li>
                    <li  class="w3-bar-item w3-button w3-orange">PHP</li>
                    <li  class="w3-bar-item w3-button w3-orange">ASP</li>
                    <li  class="w3-bar-item w3-button w3-orange">Python</li></ol>
                </div>
            </div>

            <div class="w3-half">
                <div class="w3-bar-block w3-white">
                    <h2 class="w3-bar-item">Fullstack JS</h2>
                    <ol>
                    <li class="w3-bar-item w3-button w3-orange">SQL</li>
                    <li class="w3-bar-item w3-button w3-orange">Node.js</li>
                    <li class="w3-bar-item w3-button w3-orange">MySQL</li>
                    <li class="w3-bar-item w3-button w3-orange">Mongo.db</li></ol>
                </div>
            </div>
        </div>
    </div>

    <img alt="Roadmap" src={img_backend} style={{width:'100%'}}/>
    <p class="w3-center">Chart created by GitHub user Kamranahmedse:
        <a target="_blank" href="https://github.com/kamranahmedse"><br/>
            https://github.com/kamranahmedse</a>
    </p>

    <br/>


   


</div>
        </div>
    )
}

export default Web_dev
